$(window).scroll(function () {
    if ($(this).scrollTop() >= 20) {
        $("#main_body").addClass("header_is_fixed");
    } else {
        $("#main_body").removeClass("header_is_fixed");
    }
});

jQuery(document).ready(function ($) {
    $(".add_to_cart_bottom").click(function () {
        $(".product-form__cart-submit").trigger("click");
    });

    var $container = $(".recommended-products");
    // function autoNextSlide() {
    //   console.log('auto trigar');
    //   if ($container.hasClass("slick-initialized")) {
    //     $container.find(".slick-next.slick-arrow").trigger("click");
    //   }
    // }
    /*****Sorting*********/
    var sortable_data = [];
    $(".sorting_filter").each(function (index, data) {
        var $this = $(this);
        if ($this.hasClass("sorteligible")) {
            sortable_data[$this.attr("data-sort")] = $this.html();
            $this.remove();
            //console.log("CLSSS:: "+$this.attr('data-sort') + " INED::"+ index)
        }
    });

    for (var i = 1; i < sortable_data.length; i++) {
        var html = "";

        if (sortable_data[i] !== undefined) {
            html += '<li class="new_product_item">';
            html += sortable_data[i];
            html += "</li>"; // Closing the list item
        }

        // Append to the list only if there's content
        if (html !== "") {
            $(".sort_set").append(html);
        }
    }

    console.log(sortable_data);

    /*****End sorting*********/

    var cart = $(".modal-toggle");
    /****Add to cart ajax*******/
    $(document).on("click", ".add_to_cart_ajax_cust_info", function () {
        $(".modal").removeClass("is-visible");
        var $this = $(this);
        var image = $this.parent().parent().find("img");

        // Example: auto click every 3 seconds
        // setTimeout(autoNextSlide, 300);
        // setTimeout(autoNextSlide, 500);
        // setTimeout(autoNextSlide, 700);

        /***Flying**/
        var el = $(this),
            item = el.parent(),
            // img = item.find('.pdp_image_wrraper a img'),
            img = image,
            cartTopOffset = cart.offset().top - item.offset().top,
            cartLeftOffset = cart.offset().left - item.offset().left;
        // var flyingImg = $('<img class="b-flying-img">');
        // flyingImg.attr('src', img.attr('src'));
        // flyingImg.css('width', '100').css('height', '120');

        $this.addClass("cart-loading");
        $(".recommended-products").addClass("cart-loading-reco");
        var qty = 1;
        var product_id = $this.attr("data-id");

        if (product_id != "" && qty != "") {
            if (qty > 0) {
                /*Product add to cart**/
                (data = {
                    id: product_id,
                    quantity: qty,
                }),
                    $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: data,
                        dataType: "json",
                        success: function (response) {
                            $this.removeClass("cart-loading");
                            $(".recommended-products").removeClass("cart-loading-reco");

                            /****Flying animation*******/
                            // flyingImg.animate({
                            //   top: cartTopOffset,
                            //   left: cartLeftOffset,
                            //   width: 50,
                            //   height: 50,
                            //   opacity: 0.1
                            // }, 3500, function () {
                            //   flyingImg.remove();
                            // });
                            // el.parent().append(flyingImg);
                            if ($this.attr("data-gift") == "0") {
                                bundleUpdatePopup();
                            }

                            bundleUpdate();

                            //$this.addClass('checkout_product_cst');
                            //$this.removeClass('add_to_cart_ajax_cust_info');
                            if ($this.attr("data-drawer") == "1") {
                                //$('.modal').addClass('is-visible')
                            }

                            // $('html, body').animate({
                            //     scrollTop: $("#chunk_product_list").offset().top -100
                            // }, 2000);
                        },
                        error(response, status, error) {
                            console.log(response);
                            console.log(status);
                            console.log(error);
                            $this.removeClass("cart-loading");
                            $(".recommended-products").removeClass("cart-loading-reco");
                            if (response.status == "422") {
                                alert("Error - " + response.responseJSON.errors);
                            } else {
                                alert("Sorry, Something went wrong, Please try after some time.");
                            }
                        },
                    });
            } else {
                alert("Product qty can not less then 1.");
            }
        } else {
            alert("Invalid Params");
        }
    });

    function price_set(price) {
        return parseInt(price / 100) + "." + (price % 100);
    }

    // Example: auto click every 3 seconds
    // setTimeout(autoNextSlide, 300);
    // setTimeout(autoNextSlide, 500);
    // setTimeout(autoNextSlide, 700);

    /***Bundle Popup***/
    function bundleUpdatePopup() {
        // console.log("CUSTOM")
        $("#add_to_basket").addClass("open_modal");
        $("#add_to_basket").show();
        $("body").addClass("open_product_modal");
        $(".book-cards-list").html('<li class="bundle_loading">Loading....</li>');
        $.getJSON("/cart.js", function (res, textStatus) {
            //console.log("BUNDLE ");
            //console.log(res);
            var checkout_ids = [];

            $(".cart_count_total_top").text(res.item_count);
            $(".pop_total_product").text(res.item_count);
            if (res.items.length > 0) {
                var data = res.items;
                $(".book-cards-list").html("");
                for (var i = 0; i < data.length; i++) {
                    var metafields = cstMetaFields[data[i].handle];

                    add_bundle_items_pop(data[i], data[i].quantity, metafields);
                }
            }
            if (res.items.length >= 0) {
                var data = res.items;
                console.log(data);
                if (res.items.length == 0) {
                    var item = "";
                    item += '<li class="blank-card blnclose">';
                    item += '<div class="book-cards-item">';
                    item += '<div class="book-img"><span class="plus">+</span>  </div>';
                    item += '<div class="book-title"></div>';
                    item += '<div class="book-added"></div>';
                    item += "</div>";
                    item += "</li>";
                    item += '<li class="blank-card blnclose">';
                    item += '<div class="book-cards-item">';
                    item += '<div class="book-img"><span class="plus">+</span>  </div>';
                    item += '<div class="book-title"></div>';
                    item += '<div class="book-added"></div>';
                    item += "</div>";
                    item += "</li>";
                    item += '<li class="blank-card free-book-card blnclose">';
                    item += '<div class="book-cards-item">';
                    item += '<div class="book-img"><span class="plus">+<br>FREE</span> </div>';
                    item += '<div class="book-title free-book-title">FREE</div>';
                    item += '<div class="book-added"></div>';
                    item += "</div>";
                    item += "</li>";
                    $(".book-cards-list").append(item);
                } else if (res.items.length == 1) {
                    var item = "";
                    item += '<li class="blank-card blnclose">';
                    item += '<div class="book-cards-item">';
                    item += '<div class="book-img"><span class="plus">+</span>  </div>';
                    item += '<div class="book-title"></div>';
                    item += '<div class="book-added"></div>';
                    item += "</div>";
                    item += "</li>";
                    item += '<li class="blank-card free-book-card blnclose">';
                    item += '<div class="book-cards-item">';
                    item += '<div class="book-img"><span class="plus">+<br>FREE</span> </div>';
                    item += '<div class="book-title free-book-title">FREE</div>';
                    item += '<div class="book-added"></div>';
                    item += "</div>";
                    item += "</li>";
                    $(".book-cards-list").append(item);
                } else if (res.items.length == 2) {
                    var item = "";
                    item += '<li class="blank-card free-book-card blnclose">';
                    item += '<div class="book-cards-item">';
                    item += '<div class="book-img"><span class="plus">+<br>FREE</span> </div>';
                    item += '<div class="book-title free-book-title">FREE</div>';
                    item += '<div class="book-added"></div>';
                    item += "</div>";
                    item += "</li>";
                    $(".book-cards-list").append(item);
                } else {
                }
            }
        });
    }
    function add_bundle_items_pop(response, repeat, metafields) {
        var price = parseInt(response.price / 100) + "." + (response.price % 100);
        for (i = 0; i < repeat; i++) {
            var item = "";
            item += "<li>";
            item += '<div class="book-cards-item">';
            item += '<div class="book-cross-icon remove_item_pop" data-id="' + response.variant_id + '">+</div>';
            item +=
                '<div class="book-img"><img src="' + response.image + '" alt="' + response.product_title + '"> </div>';
            item += '<div class="book-title">' + metafields.product_city_name + "</div>";
            item += '<div class="book-added">Book added!</div>';

            item += "</div>";
            item += "</li>";
            $(".book-cards-list").append(item);
        }
    }
    $(document).on("click", ".remove_item_pop", function () {
        var $this = $(this);
        $this.addClass("loading");
        var productId = $this.attr("data-id");
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
                quantity: 0,
                id: productId,
            },
            success: function (data) {
                $this.removeClass("loading");
                bundleUpdatePopup();
            },
        });
    });
    /***End bundle popup******/

    /****Target down*****/
    $(".collection_target").click(function () {
        $("#add_to_basket").removeClass("open_modal");
        $("body").removeClass("open_product_modal");
        var $this = $(this);
        $("html, body").animate(
            {
                scrollTop: $("#" + $this.attr("data-target")).offset().top - 150,
                // scrollTop: $("#"+$this.attr('data-target')).offset().top -450
            },
            1000
        );
    });
    /*****Map location popup***********/
    $(".gallery-img").click(function () {
        $("#kkkkk").html("");
        var $this = $(this);
        productIds = $this.attr("data-products");
        if (productIds != "") {
            let ids = productIds.split(",");
            if (ids.length > 0) {
                for (let index = 0; index < ids.length; index++) {
                    console.log(ids[index]);
                    product_add(ids[index]);
                }
            }
        } else {
            var product_content = "";
            product_content += '<div class="">';
            product_content += '<div class="new-price-card">';
            product_content += '<div class="new-left-product new-design">';
            product_content += '<div class="new-product_info">';
            product_content += "<p>No book available for this location!</p>";
            product_content += "</div>";
            product_content += "</div>";
            product_content += "</div>";
            product_content += "</div>";
            $("#kkkkk").html(product_content);
        }

        $(".dynamic_div").hide();
        $("body").addClass("open_modal");
        $("#myModal").show();
        $(".popup_map_1").show();
        $(".popup_map_" + $this.attr("data-id")).show();

        $(".popup_map_" + $this.attr("data-id"))
            .find(".modal-content")
            .attr("src", this.src);
    });

    /****Product Creating*******/
    function product_add(handler) {
        $.ajax({
            dataType: "json",
            type: "get",
            url: "/products/" + handler + ".js",
            success: function (data) {
                var metafields = cstMetaFields[data.handle];
                // console.log(data);
                var product_content = "";
                product_content += '<div class="new_product_item">';
                product_content += '<div class="new-price-card">';
                product_content += '<div class="new-left-product new-design">';
                product_content += '<div class="new-product_image_wrraper">';
                product_content +=
                    '<a href="' +
                    data.url +
                    '"><img class="ls-is-cached lazyloaded" src="' +
                    data.featured_image +
                    '"></a>';
                product_content += "</div>";
                product_content += '<div class="new-product_info">';
                product_content +=
                    '<a class="new-city_names" href="' + data.url + '">' + metafields.product_city_name + "</a>";
                product_content += '<a href="' + data.url + '" class="new-product_info-title">';
                product_content += "<h1>" + data.title + "</h1>";
                if (metafields.product_trip_advisor == "true") {
                    product_content +=
                        '<img data-src="//www.mysteryguides.co.uk/cdn/shop/t/41/assets/tripadvisor.webp?v=69938988451432209101692771788" class="logo_green_mobile show-mobile lazyloaded" loading="lazy" src="//www.mysteryguides.co.uk/cdn/shop/t/41/assets/tripadvisor.webp?v=69938988451432209101692771788">';
                }
                product_content += "</a>";
                product_content += '<p class="sow-mobile">' + metafields.product_excerpt + "</p>";
                product_content += "</div>";
                product_content += "</div>";

                product_content += '<div class="product-buttons custom-coll-page">';
                product_content += '<p class="priceing">';
                product_content += '<dl class="price price--listing">';
                product_content += '<div class="price__regular">';
                product_content +=
                    '<dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt>';
                product_content +=
                    '<dd><span class="price-item price-item--regular">£' +
                    parseFloat(data.price) / 100 +
                    "</span></dd>";
                product_content += "</dl>";
                product_content += "</p>";

                product_content +=
                    '<a href="' + data.url + '" class="view" data-id="' + data.variants[0].id + '">View Details</a>';
                product_content +=
                    '<button type="button" class="addtocartlist add_to_cart_ajax_cust_info add_to_cart_content" data-gift="0" data-id="' +
                    data.variants[0].id +
                    '">Add to cart</button>';
                product_content += "</div>";

                product_content += "</div>";
                product_content += "</div>";

                $("#kkkkk").append(product_content);
            },
        });
    }

    /****End Map location popup*********/

    bundleUpdate();
    function bundleUpdate() {
        $(".items_slide_container").html('<div class="bundle_loading">Loading....</div>');
        $.getJSON("/cart.js", function (res, textStatus) {
            //console.log("BUNDLE "+res);
            var checkout_ids = [];
            $(".items_slide_container").html("");
            $(".subtotal_items").text(res.item_count);
            $(".cart_count_total_top").text(res.item_count);
            $(".site-header__cart-count").removeClass("hide");
            $(".items_slide_container").removeClass("min_height_slider");
            if (res.items.length > 0) {
                var data = res.items;

                for (var i = 0; i < data.length; i++) {
                    add_bundle_items(data[i], data[i].quantity);
                    checkout_ids.push(data[i].id + ":" + data[i].quantity);
                }

                if (data.length > 2) {
                    $(".items_slide_container").addClass("min_height_slider");
                } else {
                    $(".items_slide_container").removeClass("min_height_slider");
                }
            }

            // if(checkout_ids.length > 0){

            //   var checkoutlink = "https://www.mysteryguides.co.uk/cart/"+checkout_ids.join(',');
            //   $('.checkOut_btn').attr('href',checkoutlink);
            // }

            $(".slide_cart_top_price_total").text(price_set(res.items_subtotal_price));
        });
    }
    function add_bundle_items(response, repeat) {
        var price = parseInt(response.price / 100) + "." + (response.price % 100);
        var item = "";
        item += '<div class="cart_items_slide">';

        item += '<div class="cart_items_slide">';
        item +=
            '<a href="javascript:void(0)" class="remove_item_slide_cart" data-id="' +
            response.id +
            '"  aria-describedby="a11y-external-message">Remove</a>';
        item += "</div>";
        item += '<div class="cart_images_info">';
        item += '<img src="' + response.image + '" alt="' + response.product_title + '"> ';
        item += '<div class="content_carts">';
        item += "<h5>" + response.product_title + "</h5>";
        item += "<p></p>";
        item += '<div class="price_items">';
        item += '<span class="oty">' + response.quantity + "</span>";
        item += '<span class="price">£' + price + "</span>";
        item += "</div>";
        item += "</div>";
        item += "</div>";
        $(".items_slide_container").append(item);
    }
    function setCart() {
        var carttext = 0;
        $.getJSON("/cart.js", function (cart, textStatus) {
            carttext = cart.item_count;
            $("#count_cart").text(carttext);
            $(".visually-hidden").text(carttext);
            $(".cart-notification").show();
            $("#cart_count_input").val(carttext);
        });
        return carttext;
    }
    $(document).on("click", ".remove_item_slide_cart", function () {
        var $this = $(this);
        var productId = $this.attr("data-id");
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
                quantity: 0,
                id: productId,
            },
            success: function (data) {
                $this.parent().parent().remove();
                bundleUpdate();
            },
        });
    });

    $(document).on("click", ".remove_item_slide_cart_pdp", function () {
        var $this = $(this);
        var productId = $this.attr("data-id");
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
                quantity: 0,
                id: productId,
            },
            success: function (data) {
                $(".close").trigger("click");
                window.location.reload();
            },
        });
    });


    //Build a Bundle
    $(".buildabundle_btn").click(function () {
        $(".buildabundlepopup").fadeIn(500);

        $(".buildabundle_popupslider").slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    });
    $(".close3").click(function () {
        $(".buildabundlepopup").fadeOut(500);
        $(".buildabundle_popupslider").slick("unslick");
    });

    /***Single page popup after cart**/
    $(".popup_btn").click(function () {
        var viewportHeight = $(window).height();
        var modalHeight = $("#modal").height();

        var modalTop = viewportHeight / 2 - modalHeight / 2 + 30;

        $(".modal-bg").fadeIn();
        $("#modal").css({ display: "block" });
        $("#modal")
            .delay(400)
            .animate({ top: modalTop }, 400, function () {
                $("#modal").delay(10).animate({ marginTop: -30 }, 200);
            });

        $(".main_product_recoumended").slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: true,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });

        return false;
    });

    /***Single page popup close after cart**/
    $(".close, .modal-bg").click(function () {
        $("#modal")
            .stop()
            .animate({ marginTop: "-70px" }, 200, function () {
                var viewportHeight = $(window).height();
                $("#modal")
                    .delay(10)
                    .animate({ top: viewportHeight + 400 }, 400, function () {
                        $("#modal").removeAttr("style");
                        $(".modal-bg").fadeOut();
                    });
            });
        return false;
    });
    /****Single product gallery Images*****/
    $(".product-single__thumbnails-slider-track").slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    /****Topbar cart slide show****/
    $(document).on("click", ".modal-toggle", function () {
        $(".modal").addClass("is-visible");
        $("body").addClass("modal-open");
    });
    $(document).on("click", ".modal-close", function () {
        $(".modal").removeClass("is-visible");
        $("body").removeClass("modal-open");
    });

    $(document).on("click", ".popup-video-image>a", function () {
        const video = $(".video_modal video")[0];
        $(".video_modal").addClass("is-visible");
        $("body").addClass("modal-open");
        if (video.paused) {
            video.play();
        } else {
        }
    });
    $(document).on("click", ".video_popup_close, .video_popup_overlay", function () {
        const video = $(".video_modal video")[0];
        $(".video_modal").removeClass("is-visible");
        $("body").removeClass("modal-open");
        if (video.play) {
            video.pause();
        } else {
        }
    });
});

/*** close modal click outside***/
$(document).click(function (event) {
    //if you click on anything except the modal itself or the "open modal" link, close the modal
    if (!$(event.target).closest(".modal,.modal-toggle").length) {
        $("body").find(".modal").removeClass("is-visible");
        $("body").removeClass("modal-open");
    }
});
/*** close modal click outside***/

// $(function() {
// setTimeout(function() { $("#hideModal").fadeOut(2000);  $("body").find(".modal").removeClass("is-visible"); }, 7000)
// })

/*****qty btn *******/
// var input = document.querySelector('.product-form__input--quantity');
// var btnminus = document.querySelector('.qtyminus');
// var btnplus = document.querySelector('.qtyplus');

// if (input !== undefined && btnminus !== undefined && btnplus !== undefined && input !== null && btnminus !== null && btnplus !== null) {

// 	var min = Number(input.getAttribute('min'));
// 	var max = Number(input.getAttribute('max'));
// 	var step = Number(input.getAttribute('step'));

// 	function qtyminus(e) {
// 		var current = Number(input.value);
// 		var newval = (current - step);
// 		if(newval < min) {
// 			newval = min;
// 		} else if(newval > max) {
// 			newval = max;
// 		}
// 		input.value = Number(newval);
// 		e.preventDefault();
// 	}

// 	function qtyplus(e) {
// 		var current = Number(input.value);
// 		var newval = (current + step);

// 		if(newval > max) newval = max;
// 		input.value = Number(newval);
// 		e.preventDefault();
// 	}

// 	btnminus.addEventListener('click', qtyminus);
// 	btnplus.addEventListener('click', qtyplus);
// }

$(document).ready(function () {
    var $input = $(".product-form__input--quantity");
    var $btnminus = $(".qtyminus");
    var $btnplus = $(".qtyplus");
    var min = parseFloat($input.attr("min"));
    var max = parseFloat($input.attr("max"));
    var step = parseFloat($input.attr("step"));

    function updateQuantity(offset) {
        var current = parseFloat($input.val());
        var newval = current + offset;
        newval = Math.min(max, Math.max(min, newval));
        $input.val(newval);
    }

    $btnminus.click(function (e) {
        updateQuantity(-step);
        e.preventDefault();
    });

    $btnplus.click(function (e) {
        updateQuantity(step);
        e.preventDefault();
    });
});

/****End Bunddle list slider init*****/
/*********** sliding cart fixed on scroll *********/
$(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
        $(".modal-wrapper").addClass("modal-wrapper-fixed");
    } else {
        $(".modal-wrapper").removeClass("modal-wrapper-fixed");
    }
});

$(window).scroll(function () {
    if ($(this).scrollTop() > 210) {
        $(".modal").addClass("modal-fixed");
    } else {
        $(".modal").removeClass("modal-fixed");
    }
});
//backtotop
$(window).scroll(function () {
    if ($(this).scrollTop() > 600) {
        $("#backtotop").addClass("showbtn");
    } else {
        $("#backtotop").removeClass("showbtn");
    }

    if ($(this).scrollTop() > 600) {
        $("#sticky-add-to-cart").show();
    } else {
        $("#sticky-add-to-cart").hide();
    }

    // if ($(this).scrollTop() > 600) {
    //      $('.fixed-add-to-cart').addClass('fixed--cart');
    //  } else {
    //      $('.fixed-add-to-cart').removeClass('fixed--cart');
    //  }
});
//
if ($(".only-for-mobile .new-pdp-two-ext-btn").length) {
    function addcart_relocate() {
        var window_top = $(window).scrollTop();
        var div_top = $(".only-for-mobile .new-pdp-two-ext-btn").offset().top + 50;
        console.log(div_top);
        if (window_top > div_top) {
            $(".fixed-add-to-cart").addClass("fixed--cart");
        } else {
            $(".fixed-add-to-cart").removeClass("fixed--cart");
        }
    }

    $(function () {
        $(window).scroll(addcart_relocate);
        addcart_relocate();
    });
} else {
}

//backtotop_2
$(window).scroll(function () {
    if ($(this).scrollTop() > 600) {
        $("#backtotop_2").addClass("showbtn");
    } else {
        $("#backtotop_2").removeClass("showbtn");
    }
    if ($(".new-vote-section").length) {
        if ($(this).scrollTop() > 600) {
            $(".new-vote-section").addClass("vote-section-show");
        } else {
            $(".new-vote-section").removeClass("vote-section-show");
        }
    }

    if ($(this).scrollTop() > 300) {
        $(".sticky_map").addClass("show_map");
    } else {
        $(".sticky_map").removeClass("show_map");
    }
});
//
//buildabundle1
$(window).scroll(function () {
    if ($(this).scrollTop() > 660) {
        $("#buildabundle1").addClass("showbtn");
    } else {
        $("#buildabundle1").removeClass("showbtn");
    }
});
//search-field

$(".search-field").on("click", function () {
    $(".search-field").removeClass("showbtn");
    $(this).addClass("showbtn");
});
//search-field
$(function () {
    $(".search-field").click(function () {
        $(".search-submit").removeClass("active");
        $(".search-submit").addClass("active");
    });
});
//wobblecart_icon header
(function ($) {
    $.fn.addClassAndRemove = function (classAdd, timeAdd, timeRemove) {
        let element = this;
        let addIt = function () {
            element.addClass(classAdd);
        };
        let removeIt = function () {
            element.removeClass(classAdd);
        };
        setTimeout(function () {
            addIt();
            setTimeout(removeIt, timeRemove);
        }, timeAdd);
        return this;
    };
})(jQuery);

// Just to call the function and see how it works
$(".addtocartlist")
    .off()
    .click(function (e) {
        $(".d_flex >.header_cart_item").addClassAndRemove("wobblecart_icon", 0, 1500); // function called with parameters
    });
//buildabundle_btn click on header hide and announcement show
$(document).ready(function () {
    $(".buildabundle_btn").click(function () {
        $(".site-header").addClass("headerhide");
    });
    $(".buildabundlepopup .close3").click(function () {
        $(".site-header").removeClass("headerhide");
    });
    $(".buildabundle_btn").click(function () {
        $(".header_bottom_checkout").addClass("header_bottom_checkout_show");
    });
    $(".buildabundlepopup .close3").click(function () {
        $(".header_bottom_checkout").removeClass("header_bottom_checkout_show");
    });
});

///////////open new bundale modal /////////////////////

$(document).ready(function () {
    console.log("popup ready!");
    $(".add_to_basket").on("click", function () {
        $("#add_to_basket").addClass("open_modal");
        $("#add_to_basket").show();
        $("body").addClass("open_product_modal");
    });

    $(".add_to_basket_close").on("click", function () {
        $("#add_to_basket").removeClass("open_modal");
        $("body").removeClass("open_product_modal");
        $("#add_to_basket").hide();
    });
    $(".add_to_basket_close_icon ").on("click", function () {
        $("#add_to_basket").removeClass("open_modal");
        $("body").removeClass("open_product_modal");
        $("#add_to_basket").hide();
    });

    $("body").on("click", ".blnclose", function () {
        $("#add_to_basket").removeClass("open_modal");
        $("body").removeClass("open_product_modal");
        $("#add_to_basket").hide();
    });
    $(".pdp-popup-build-btn .collection-page-show").on("click", function () {
        $("#add_to_basket").removeClass("open_modal");
        $("body").removeClass("open_product_modal");
        $("#add_to_basket").hide();
    });

    $(".pdp-popup-build-btn .pdp-page-show").on("click", function () {
        var modal = $("#myModal");
        setTimeout(function () {
            modal.css("display", "none");
            $(".map-pin-marker").removeClass("map-pin-out");
            $("body").removeClass("open_modal");
        }, 400);
    });
});

function modaladdCartItem(element) {
    const isGift = element.getAttribute("data-gift");
    const variantId = element.getAttribute("data-id");
    const cityName = "Gift Card";
    if (isGift != "1") {
        addtoCart(isGift, variantId, null, cityName);
    }
}

function addtoCart(isGift, variantId, button = null, cityName) {
    const hasButton = button instanceof HTMLElement;
    if (isGift !== "1" && variantId) {
        if (hasButton) {
            showLoader(button, true);
            button.disabled = true;
        }
        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                items: [
                    {
                        id: variantId,
                        quantity: 1,
                        properties: {
                            cityName: cityName,
                        },
                    },
                ],
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                headerCartUpdate();

                setTimeout(() => {
                    if (hasButton) {
                        showLoader(button, false);
                        button.disabled = false;
                    }
                    //bundleUpdatePopupSingle();
                }, 1000);
            })
            .catch((error) => {
                console.error("Add to cart failed:", error);
                if (hasButton) {
                    showLoader(button, false);
                    button.disabled = false;
                }
            });
    }
}

function headerCartUpdate() {
    fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
            const totalItems = cart.item_count;

            // Desktop cart count
            const desktopCartCount = document.querySelector(".menu_wrap_rigt .cart_count_total_top");
            if (desktopCartCount) {
                desktopCartCount.textContent = totalItems;
                desktopCartCount.setAttribute("data-cart-count", totalItems);
            }
        })
        .catch((error) => console.error("Failed to fetch cart count:", error));
}

document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".recommended-products");

    // Remove slick if previously initialized
    if ($(container).hasClass("slick-initialized")) {
        $(container).slick("unslick");
    }

    container.innerHTML = "";
    container.style.visibility = "visible"; // Make visible before initializing

    const productHandles = [
        "londontower",
        // "lincoln",
        "york",
        // "chester"
        "physical-gift-card-sent-in-the-post",
    ];

    function fetchProduct(handle) {
        return fetch(`/products/${handle}.js`)
            .then((res) => (res.ok ? res.json() : null))
            .catch(() => null);
    }

    // function initSlick() {

    //     const slideCount = container.querySelectorAll(".gift-card").length;
    //     const infinite = slideCount > 3;
    //     if ($('.recommended-products').hasClass('slick-initialized')) {
    //       $('.recommended-products').slick('unslick');
    //       console.log('slick destroy run');
    //     }
    //     console.log('slide run');
    //     $(".recommended-products").slick({
    //         slidesToShow: Math.min(3, slideCount),
    //         slidesToScroll: 1,
    //         arrows: true,
    //         dots: false,
    //         infinite: false,
    //         autoplay: false,
    //         autoplaySpeed: 2000,
    //         prevArrow: '<button type="button" class="slick-prev">&lt;</button>',
    //         nextArrow: '<button type="button" class="slick-next">&gt;</button>',
    //         responsive: [
    //             { breakpoint: 1024, settings: { slidesToShow: Math.min(3, slideCount) } },
    //             { breakpoint: 768, settings: { slidesToShow: Math.min(3, slideCount) } }
    //         ]
    //     });
    // $('.recommended-products').slick('slickNext');
    // setTimeout(() => {
    //     $('.recommended-products').slick('slickNext');
    // }, 5000);

    // }
    // setTimeout(() => {
    //     initSlick();
    // }, 1000);

    Promise.all(productHandles.map(fetchProduct))
        .then((products) => {
            const validProducts = products.filter((p) => p);
            if (!validProducts.length) return;

            validProducts.forEach((product) => {
                const variantId = product.variants[0]?.id;
                const image = product.images?.[0] || "";
                const item = `
              <div class="gift-card">
                  <button type="button" class="gift-card-imgbtn add_to_cart_ajax_cust_info" data-gift="0" data-drawer="0" data-id="${variantId}">
                  
                      <img src="${image}" alt="${product.title}">
                  </button>
                  <button type="button" class="gift-card-btn cstm-btn-add-modal add_to_cart_ajax_cust_info" data-gift="0" data-drawer="0" data-id="${variantId}">+</button>
              </div>
          `;

                // onclick="modaladdCartItem(this)"   crete issue of double book added
                container.insertAdjacentHTML("beforeend", item);
            });

            //console.log("Run")

            // Initialize Slick after a short delay to ensure widths are correct
            //setTimeout(initSlick, 1000);
        })
        .catch((err) => console.error("Error loading recommended products:", err));
});

$(document).ready(function () {
    if ($("body").hasClass("template-index")) {
        $(window).on("scroll", function () {
            const $btn = $(".sticky-adventure-btn");
            if (!$btn.length) return;

            if ($(window).scrollTop() > 100) {
                $btn.addClass("show");
            } else {
                $btn.removeClass("show");
            }
        });
    } else {
        const $btn = $(".sticky-adventure-btn");
        if ($btn.length) $btn.remove();
    }
});



    /********* homepage review slider *******/
    document.addEventListener("DOMContentLoaded", function () {
      if (typeof jQuery !== "undefined") {
        jQuery(function ($) {

          setTimeout(function () {

            if ($.fn.slick) {

              if ($('.main-review_wrraper').length &&
                  !$('.main-review_wrraper').hasClass('slick-initialized')) {

                $('.main-review_wrraper').slick({
                  infinite: true,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  arrows: false,

                  responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        arrows: false,
                        autoplay: true
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        autoplay: true
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        autoplay: true
                      }
                    }
                  ]
                });

              }

            } else {
              console.log("Slick not loaded");
            }

          }, 1000);

        });
      }
    }); 
